<PreventiveMaintenanceCommonDetail title="Preventive Maintenance Detail"  ListURL="Home/PreventiveMaintenanceSearch" detailsType="Home"
></PreventiveMaintenanceCommonDetail>